export default {
      id: "ic_campaigns_green_new-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_campaigns_green_new-usage",
      toString: function () {
        return this.url;
      }
    }